import { useQuery } from "@tanstack/react-query";
import { AccountService } from "@/services/account/AccountService";
import useAuth from "components/modules/Auth/useAuth";

export function useActiveSubscriptionQuery() {
    const { isLoggedIn } = useAuth();
    return useQuery({
        queryKey: ["activeSubscriptionQuery"],
        enabled: isLoggedIn(),
        queryFn: async () => AccountService.getActiveSubscription(),
    });
}
